<template>
<div class="content">
  <div class="largeTitile" >田野溯源管理系统</div>

  <van-row class="box-notice">
    <van-col span="4"><van-icon name="success" size="40" /></van-col>
    <van-col span="19" offset="1">
      <ul class="box-text">
        <li>商品验证通过</li>
        <li>该产品已通过全链路溯源认证</li>
        <li>溯源编号：{{info.traceabilityCode || '--'}}</li>
      </ul>
    </van-col>
  </van-row>

  <van-collapse v-model="activeNames" class="box-content">
    <van-collapse-item v-for="(item, index) in tabList" :title="item" :name="index" :key="index" class="collapse-item">
      <van-row v-if="index==0">
        <ul class="box-text">
          <li>公司名称：{{info.companyName}}</li>
          <li>法定代表人：{{info.companyLegalRepresentative}}</li>
          <li>成立日期：{{info.companyDate}}</li>
          <li>电话：{{info.companyTelephoneNumber}}</li>
          <li>地址：{{info.companyAddress}}</li> 
          <li class="flex flex-center color-F59A23" @click="onClickCredentials">查看企业资质 <van-icon name="arrow" /></li> 
        </ul>
      </van-row>
      
      <van-row v-if="index==1">
        <van-steps direction="vertical" :active="activeSteps"  class="box-text">
          <van-step>
            <h3>{{info.traceabilityTransDateStrOne}}</h3>
            <p>商品订单录入完成</p>
          </van-step>
          <van-step>
            <h3>{{info.traceabilityTransDateStrTwo}}</h3>
            <p>田野通知采购备货</p>
          </van-step>
          <van-step>
            <h3>{{info.traceabilityTransDateStrThree}}</h3>
            <p>商品分拣打包完成</p>
          </van-step>
          <van-step>
            <h3>{{info.traceabilityTransDateStrFour}}</h3>
            <p>司机装车完成</p>
          </van-step>
        </van-steps>
      </van-row>

      <van-row v-if="index==2">
        <van-row class="flex flex-justify-between flex-wrap" style="padding-bottom:20px;">
          <van-button class="width-30pc botton-records" v-for="(item, index) in dtlMapKeys" :key="index" type="info" @click="onClickRecords(item)">{{ item }}</van-button>
        </van-row>
      </van-row>

      <van-row v-if="index==3">
        <van-row class="flex flex-justify-between"> 
          <van-search
            v-model="searchValue"
            show-action
            clear-trigger="always"
            placeholder="请输入商品名称"
            @search="onSearch"
          >
            <template #action>
              <div @click="onSearch">搜索</div>
            </template>
          </van-search>
        </van-row>
        <van-row class="box-goods">
          <van-row v-for="(item, index) in info.dtlList" :key="index" class="box-goods-item flex flex-align-center">
            <van-col span="16">
              <ul class="box-text">
                <li>商品名称: {{ item.goodsName }}</li>
                <li :class="item.originName ? '' : 'visibility-hidden'">商品产地: {{ item.originName }}</li>
                <li class="flex flex-center color-F59A23" @click="onClickSupplier(item)">查看供应商 <van-icon name="arrow" /></li>
              </ul>
            </van-col>
            <van-col span="7" offset="1"><img :src="item.picUrl" style="width:100%" /></van-col>
          </van-row>
        </van-row>
      </van-row>
      
    </van-collapse-item>
    
  </van-collapse>

  <!-- 弹框 -->
  <van-dialog v-model="showDialog" :title="showDialogTitle" confirmButtonText="关闭" class="box-credentials">
    <!--查看企业资质 -->
    <van-row class="content flex flex-baseline" v-if="showDialogType == 0">
      <van-col span="10" :offset="1">
        <img :src="info.businessLicense" style="width:100%" @click="onPreviewImg([info.businessLicense])" />
        <van-row>营业执照</van-row>
      </van-col>
      <van-col span="10" :offset="2">
        <img :src="info.foodBusinessLicense" style="width:100%" @click="onPreviewImg([info.foodBusinessLicense])" />
        <van-row>食品经营许可证</van-row>
      </van-col>
    </van-row>

    <!--查看检测报告 -->
    <van-row class="content content-dialog" v-if="showDialogType == 1">
      <van-col v-for="(item, index) in info.dtlMap[showDialogTitle]" :key="index" span="18" :offset="3">
        <img :src="item.fileUrl" style="width:100%" @click="onPreviewImg([item.fileUrl])" />
      </van-col>
    </van-row>

    <!--查看供应商 -->
    <van-row class="content flex flex-baseline" v-if="showDialogType == 2">
      <van-col span="10" :offset="1">
        <img :src="clickGoodsItem.businessLicense" style="width:100%" @click="onPreviewImg([clickGoodsItem.businessLicense])" />
        <van-row>营业执照</van-row>
      </van-col>
      <van-col span="10" :offset="2">
        <img :src="clickGoodsItem.foodCirculationLicense" style="width:100%" @click="onPreviewImg([clickGoodsItem.foodCirculationLicense])" />
        <van-row>食品流通许可证</van-row>
      </van-col>
    </van-row>

  </van-dialog>

  <van-image-preview v-model="showImgPreview" :images="showImgPreviewImgs" />

  <van-popup @click="closePop" v-model="show"  class="imgPopup">
    <v-touch @pinchin="growLarger" @pinchout="growSmall">
      <img  :src="picurl" alt="" :style="scaleFun" class='large_pic' >
    </v-touch>
  </van-popup>
  <van-popup v-model="show1" class="imgPopup" @click="closePop1">
    <v-touch  @pinchin="growLarger" @pinchout="growSmall"  :swipe-options="{ direction: 'horizontal'}"  @swipeleft="left1(pdfList.traceabilityLabel,pdfList.subscribeTraceabilityId)" @swiperight="right1(pdfList.traceabilityLabel,pdfList.subscribeTraceabilityId)">
      <div ref="zoom" class="pdf pdfBox1" :style="scaleFun"  >
          <pdf
          :src="pdfList.fileUrl" 
          :page="pdfList.currentPage"
          @num-pages="pdfList.pageCount=$event" 
          @page-loaded="pageLoaded" 
          @loaded="pdfList.currentPage=1 "> 
          </pdf>
          <div class="footer1">{{pdfList.currentPage}}/{{pdfList.pageCount}}</div>
      </div>
    </v-touch>
  </van-popup>
</div>
</template>
<script>
import pdf from 'vue-pdf'
// import Hammer from 'hammerjs';
// import {zoomElement} from '../util/zomm'
// import pdf from 'vue-pdf-app'
// import { showImagePreview } from 'vant';

import Vue from 'vue';
import { Lazyload } from 'vant';

Vue.use(Lazyload);
// Vue.use(AliVideo);

  export default {
    components: {pdf},
    props:{
      pathurl: { type: String },
    },
    data () {
      return {
        searchValue: '',
        showImgPreview: false,
        showImgPreviewImgs: [],
        clickGoodsItem: {},
        showDialog: false,
        showDialogTitle: '',
        showDialogType: '',


        activeIndex: 0,
        totalPage: 0,
        // currentPage: 1,
        // 仅渲染当前、上一页、下一页，防止DOM爆炸
        renderPageList: [1,2],
        tabList: [
          '企业信息',
          '商品流通信息',
          '检测报告',
          '商品信息',
        ],
        activeNames: [0,1,2,3],
        info: {}, 
        currentPage: 0, // pdf文件页码
        pageCount: 0, // pdf文件总页数 
        fileType: 'pdf', // 文件类型
        // src: "", // pdf文件地址
        src: "http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf", // pdf文件地址
        list:{},
        picurl:'',
        show:false,
        show1:false,
        pdfList:'',
        scale:1,
      }
    }, 
    created () {
      this.query()
    } ,
    mounted() {
    },
    computed:{
      dtlMapKeys() {
        const { dtlMap } = this.info
        return Object.keys(dtlMap)
      },
      activeSteps() {
        const { traceabilityTransDateStrOne , traceabilityTransDateStrTwo, traceabilityTransDateStrThree, traceabilityTransDateStrFour } = this.info
        return [
          traceabilityTransDateStrOne ? 0 : -1,      
          traceabilityTransDateStrTwo ? 1 : -1,
          traceabilityTransDateStrThree ? 2 : -1,
          traceabilityTransDateStrFour ? 3 : -1,
        ].sort().reverse()[0]
      },
      scaleFun() {
        let scale = this.scale;
        return `transform:scale(${scale})`
      }
    },
    methods: {
      onSearch() {
        this.query(this.searchValue)
      },
      openDialog(value) {
        this.showDialogTitle = value
        this.showDialog = true
      },
      onClickSupplier(item) {
        this.showDialogType = '2'
        this.clickGoodsItem = item
        this.openDialog(item.supplierName)
      },
      onClickRecords(item) {
        this.showDialogType = '1'
        this.openDialog(item)
      },
      onClickCredentials() {
        this.showDialogType = '0'
        this.openDialog(this.info.companyName)
      },
      onPreviewImg (imgs ) {
        this.showImgPreview = true
        this.showImgPreviewImgs = imgs
      },
      async query(param){
        // this.src = pdf.createLoadingTask(this.src)
        const { time, customerCode } = this.$route.query
        const queryParam = param || ''
        const params = `time=${time}&customerCode=${customerCode}&param=${queryParam}`
        const res = await this.$axios.get(`subscribe/subscribeTraceability/traceability/show?${params}`)
        const resData = res.data.data

        this.info = resData
        // this.tabList.forEach(item => {
        //   item.options.forEach(v => {
        //     this.info[`${v.value}FileList`].forEach(x => {
        //       x.currentPage = 1
        //       x.pageCount = 1
        //     })

        //   })
        // }) 
      },


      getFileSuffix(url) {
        const name = url
        if (name==undefined) {
          return ''
        }
        // 找到最后一个 . 的位置
        const dotIndex = name.lastIndexOf('.')
        if (dotIndex === -1) return ''
        return name.slice(dotIndex + 1).toLowerCase()
      },
      left(name,vid) {
         let currentArr = this.list[name].find(v => v.subscribeTraceabilityId == vid)
        if(currentArr.currentPage < currentArr.pageCount ) {
          currentArr.currentPage++
        }
      },
      right(name,vid) {
        let currentArr = this.list[name].find(v => v.subscribeTraceabilityId == vid)
        if(this.currentPage > 1 ) {
          currentArr.currentPage--
        }
      },
      left1() {
        if(this.pdfList.currentPage < this.pdfList.pageCount ) {
          this.pdfList.currentPage++
        }
      },
      right1() {
        if(this.currentPage > 1 ) {
          this.pdfList.currentPage--
        }
      },
      taptap(v) {
        this.pdfList = v
        this.show1 = true
      },
      // pdf加载时
      loadPdfHandler () {
        this.currentPage = 1 // 加载的时候先加载第一页
      },
      pageLoaded(v) {
        this.currentPage = v
      },
      showPopup(e) {
        this.picurl = e.target.currentSrc
        this.show = true;
      },
      growLarger(e) {
        this.scale = e.scale
      },
      growSmall(e) {
        this.scale = e.scale
      },
      closePop() {
        this.show = false
        this.scale = 1
      },
      closePop1() {
        this.show1 = false
        this.scale = 1

      },
    }
  }

</script>
<style scoped>
  .content {
    background-color: #efefef;
  }
  .content-dialog {
    max-height: 380px;
    overflow-y: scroll;
  }
  .largeTitile {
    height: 60px;
    background-color: #fff;
    font-size: 20px;
    line-height: 60px;
    text-align: center;
    color: #000;
    font-weight: 700;
    margin: 0 -20px;
  }
  .box-notice {
    background-color: #3c9440; 
    color: #fff;
    padding: 20px;
  }
  .box-text {
    line-height: 32px;
  }
  .box-content {
    /* padding: 12px 0; */
  }
  .box-content .box-title {
    padding-left: 12px;
    height: 48px;
    line-height: 48px;
    color: #fff;
    background-color: #687e97;
  }
  .box-content .box-text {
    color: #000;
  }

  .box-credentials .content {
    padding: 20px;
    background-color: #fff;
  }
  .box-goods {
    /* border: solid 1px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 12px;
    margin-top: 20px; */
  }
  .box-goods-item {
    border: solid 1px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 12px;
    margin-top: 20px;
  }

  .botton-records {
    margin-bottom: 12px!important;
  }


.collapse-item {
  margin: 12px 0;
}
.van-cell__title {
  font-weight: 600!important;
}

.text-blod-600 {
  font-weight: 600;
}

.my-swipe .van-swipe-item {
    color: #fff;
    height: 500px;
    text-align: center;
    /**background-color: #39a9ed;**/
  }
  .my-swipe .van-swipe-item .img {
    width: 100%;
  }

  .footer {
    width: 40px;
    height: 15px;
    line-height: 15px;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 450px;
    right: 50px;
    border-top-left-radius:10px;
    border-top-right-radius:10px;
    border-bottom-left-radius:10px;
    border-bottom-right-radius:10px;
    color:#f6ecec;
    text-align: center;
  }
  .footer1 {
    width: 40px;
    height: 15px;
    line-height: 15px;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 400px;
    right: 50px;
    border-top-left-radius:10px;
    border-top-right-radius:10px;
    border-bottom-left-radius:10px;
    border-bottom-right-radius:10px;
    color:#f6ecec;
    text-align: center;
  }
  .pdfBox {
    position: relative;
  }
  .pdfBox1 {
    position: fixed;
    width: 300px;
    height: 500px;
    top: 20%;
    left: 15%;
  }
  .category {
    font-size: 23px;
    font-weight: 700;
    margin-right: 20px;
    color: #205792;
  }
  .name {
    font-size: 20px;
    font-weight: 500;
    color: #205792;
  }
  .titile {
  background-color: #E8EEF4;
  border-radius: 10px;
  padding: 0 10px;
  margin-top: 10px;
  margin-bottom: 15px;
  height: 70px;
  line-height: 70px;
  }
  .large_pic {
    width: 100%;
    height: auto;
    display: block;
    /* position: fixed; */
    margin: 0 auto;
    /* top: 200px;
    left: 0; */
    /* transform:scale() */
  }
  .large_pic1 {
    text-align: center;
    margin: auto;
  }
    .imgPopup {
      width: 100%;
      height: 100%;
      background-color: #000;
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
</style>